<template>
    <div class="text-center">
        <table class="table">
            <thead>
            <tr>
                <th v-text="$t('label.identifier')" class="bg-white"></th>
                <th v-text="$t('label.full_name')" class="bg-white"></th>
                <th v-text="$t('label.phone')" class="bg-white"></th>
                <th v-text="$t('marketing.marketing_setting.marketing_percent')" class="bg-white"></th>
                <th v-text="$t('label.percent')" class="bg-white"></th>
                <th v-text="$t('datatable.actions')" class="bg-white"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in referer_list" :key="index">
                <td v-text="item.id"></td>
                <td v-text="item.full_name"></td>
                <td v-text="item.phone"></td>
                <td v-text="typeStr.get(item.marketing_profit_type)"></td>
                <td v-text="item.referer_percent"></td>
                <td>
                    <button type="button" class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm"
                            @click="deleteRow(index)">
                        <span class="tooltip-text">حذف</span>
                        <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"
                                         fill="#ff6060"><path d="M0 0h24v24H0V0z" fill="none"/><path
                                        d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10zM18 4h-2.5l-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1z"/></svg>
                                </span>
                    </button>
                    <button type="button" class="special-tooltip btn btn-sm btn-clean btn-icon btn-icon-sm"
                            @click="editRow(index)">
                        <span class="tooltip-text">  {{ $t('marketing.edit_referer') }}</span>
                        <span class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                <i class="fa fa-eye"></i>
                            </span>
                    </button>
                </td>
            </tr>
            </tbody>
        </table>
        <div class="modal fade" id="edit_referer_modal" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">
                        <form @submit.prevent="editReferer()" id="edit_referer_form">
                            <div v-if="edit_referer != null" class="row">
                                <div class="col-12 col-md-6 my-2">
                                    <label for="title" v-text="$t('label.referer')"></label>
                                    <input id="title"
                                           name="title"
                                           disabled
                                           v-model="edit_referer.title"
                                           class="form-control">
                                </div>
                                <div class="col-12 col-md-3 my-2">
                                    <label for="title"
                                           v-text="$t('marketing.marketing_setting.marketing_percent')"></label>
                                    <select
                                        v-model="edit_referer.marketing_profit_type"
                                        name="marketing_profit_type"
                                        id="marketing_profit_type"
                                        @change="updateProfitPercentBasedOnType"
                                        class="form-control"
                                    >
                                        <option
                                            v-bind:key="index"
                                            v-for="(type, index) in marketingProfitTypes"
                                            v-bind:value="type"
                                        >
                                            {{ typeStr.get(type) }}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12 col-md-3 my-2">
                                    <label for="referer_percent" v-text="$t('label.percent')"></label>
                                    <input id="referer_percent"
                                           :disabled="edit_referer.marketing_profit_type !== marketingProfitTypes.SPECIFIC_USER_PROFIT"
                                           name="referer_percent"
                                           v-model="edit_referer.referer_percent"
                                           class="form-control">
                                </div>
                            </div>
                            <div>
                                <button type="button" class="mx-2 btn btn-secondary" @click="resetEditReferer()"
                                        data-dismiss="modal" v-text="$t('label.cancel')"></button>
                                <button type="submit" class="mx-2 btn btn-primary" v-text="$t('btn.edit')"></button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>
<script>
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import {typeStr, marketingProfitTypes} from '@/constants/marketingProfitType'
import toastr from "toastr";


export default {
    props: ['referer_list', 'has_error', 'error_text'],
    data() {
        return {
            edit_referer: {},
            typeStr,
            marketingProfitTypes
        };
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },

    },
    methods: {
        deleteRow(index) {
            this.referer_list.splice(index, 1);
        },
        editRow(index) {
            this.edit_referer = {
                index: index,
                title: this.referer_list[index].full_name,
                marketing_profit_type: this.referer_list[index].marketing_profit_type,
                specific_referer_profit_percent: this.referer_list[index].specific_referer_profit_percent ? parseFloat(this.referer_list[index].specific_referer_profit_percent) : 0,
                use_specific_referer_profit_percent: this.referer_list[index].use_specific_referer_profit_percent,
                specific_user_profit_percent: parseFloat(this.referer_list[index].referer_percent),
                default_profit_percent: this.referer_list[index].default_profit_percent ? parseFloat(this.referer_list[index].default_profit_percent) : 0,
                referer_percent: parseFloat(this.referer_list[index].referer_percent)
            }
            $('#edit_referer_modal').modal('toggle');
        },
        editReferer() {
            let index = this.edit_referer.index;
            let percent = this.edit_referer.referer_percent;
            let marketing_profit_type = this.edit_referer.marketing_profit_type;
            if (percent > 100) {
                return this.toastr.error(i18n.t('marketing.sum_percents_error'))
            }
            if (percent === 0 && ((marketing_profit_type !== this.marketingProfitTypes.SPECIFIC_REFERER_PROFIT) ||
                (marketing_profit_type === this.marketingProfitTypes.SPECIFIC_REFERER_PROFIT &&
                    !this.edit_referer.use_specific_referer_profit_percent))) {
                return this.toastr.error(i18n.t('marketing.percent_error'));
            }
            this.referer_list[index].referer_percent = parseFloat(percent);
            this.referer_list[index].marketing_profit_type = marketing_profit_type;
            this.resetEditReferer();
        },
        resetEditReferer() {
            this.edit_referer = {};
            $('#edit_referer_modal').modal('toggle');
        },
        updateProfitPercentBasedOnType() {
            let marketing_profit_type = this.edit_referer.marketing_profit_type;
            if (marketing_profit_type === marketingProfitTypes.SPECIFIC_USER_PROFIT) {
                this.edit_referer.referer_percent = this.edit_referer.specific_user_profit_percent;
            } else if (marketing_profit_type === marketingProfitTypes.SPECIFIC_REFERER_PROFIT) {
                this.edit_referer.referer_percent = this.edit_referer.specific_referer_profit_percent;
            } else if (marketing_profit_type === marketingProfitTypes.DEFAULT_PROFIT) {
                this.edit_referer.referer_percent = this.edit_referer.default_profit_percent;
            }
        },
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    }
}
</script>
<style scoped>

</style>